import React from "react";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

export const HowItWorks = () => {
  const { t } = useLang();

  return (
    <section id="how" className="cfg relative py-16 md:py-24 bg-white overflow-hidden" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-12">
          <Reveal>
            <p className="cfg-body text-[12px] font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-3">{t.how.overline}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="cfg-display text-3xl md:text-5xl text-[#071B2F] tracking-tight">{t.how.title}</h2>
          </Reveal>
        </div>

        <div className="space-y-0">
          {t.how.steps.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.08}>
              <div className="group relative grid grid-cols-1 md:grid-cols-12 gap-5 items-center py-8 border-t border-[#071B2F]/10 last:border-b" data-testid={`how-step-${i}`}>
                <div className="md:col-span-3 relative">
                  <span className="cfg-display text-[18vw] md:text-[7vw] leading-none text-[#D4AF37]/10 group-hover:text-[#D4AF37]/20 transition-colors absolute -top-6 md:-top-8 left-0 pointer-events-none select-none">{step.n}</span>
                  <span className="relative cfg-body text-sm font-semibold tracking-widest text-[#D4AF37]">{step.n}</span>
                </div>
                <h3 className="md:col-span-3 cfg-display text-2xl md:text-3xl text-[#071B2F]">{step.t}</h3>
                <p className="md:col-span-6 cfg-body text-[#071B2F]/55 md:text-lg max-w-xl">{step.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
